import * as api from '@/backend/api'
import { errorMessages, isErrorResponse, parseError } from '@/backend/error'
import type { ApiResult, SSOPayload } from './types'

export const createSSOConfig = async (payload: {
  teamId: number
  config: string
}): Promise<ApiResult<SSOPayload>> => {
  try {
    const response = await api.post<SSOPayload>(`/teams/${payload.teamId}/sso/saml`, {
      idp_metadata: payload.config,
    })
    return { ok: true, data: response.data }
  } catch (error) {
    if (!isErrorResponse(error)) {
      throw error
    }
    const reason = error.response?.data?.errors?.detail
    return {
      ...parseError(
        error,
        typeof reason === 'string' ? { default: reason } : errorMessages.SAVE_SSO_CONFIG,
      ),
      ok: false,
    }
  }
}
